module.exports = __webpack_public_path__ + "assets/img/advantage_bg.0c8eeaf7.png";